import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/zidian/index'
import control6Setup from '@/pages/zidian/control6Setup'
import control6Property from '@/pages/zidian/control6Property'
import control6Literature from '@/pages/zidian/control6Literature'
import control6Information from '@/pages/zidian/control6Information'
import login from '@/pages/zidian/login'
import hklogin from '@/pages/zidian/hklogin'
import control5Mymission from '@/pages/zidian/control5Mymission'
import control5Privateletter from '@/pages/zidian/control5Privateletter'
import control5Leavingmessage from '@/pages/zidian/control5Leavingmessage'
import control4Content from '@/pages/zidian/control4Content'
import control2Content from '@/pages/zidian/control2Content'
import examination from '@/pages/zidian/examination'
import control1Result from '@/pages/zidian/control1Result'
import control1Selection from '@/pages/zidian/control1Selection'
import control3Summary from '@/pages/zidian/control3Summary'
import control3Wordshockjc from '@/pages/zidian/control3Wordshockjc'
import control3Wordshocksx from '@/pages/zidian/control3Wordshocksx'
import control3Synchronoustext from '@/pages/zidian/control3Synchronoustext'
import control3Phoneticalphabet from '@/pages/zidian/control3Phoneticalphabet'
import control3SymbolReport from '@/pages/zidian/control3SymbolReport'
import control3RootWordReport from '@/pages/zidian/control3RootWordReport'
import control3CourseReport from '@/pages/zidian/control3CourseReport'
import control3ReadReport from '@/pages/zidian/control3ReadReport'
import control3YufaReport from '@/pages/zidian/control3YufaReport'
import dictationtools from '@/pages/zidian/dictationtools'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect:'/login',
    },
    {
      path: '/index',
      name: 'Index',
      component: Index,
			children: [
			  {
			    path: '/control6Setup',
			    name: 'control6Setup',
			    component: control6Setup,
			  },
				{
				  path: '/control6Property',
				  name: 'control6Property',
				  component: control6Property,
				},{
				  path: '/control6Literature',
				  name: 'control6Literature',
				  component: control6Literature,
				},
				{
				  path: '/control6Information',
				  name: 'control6Information',
				  component: control6Information,
				},
				{
				  path: '/control5Mymission',
				  name: 'control5Mymission',
				  component: control5Mymission,
				},
				{
				  path: '/control5Privateletter',
				  name: 'control5Privateletter',
				  component: control5Privateletter,
				},
				{
				  path: '/control5Leavingmessage',
				  name: 'control5Leavingmessage',
				  component: control5Leavingmessage,
				},
				{
				  path: '/control4Content',
				  name: 'control4Content',
				  component: control4Content,
				},
				{
				  path: '/control2Content',
				  name: 'control2Content',
				  component: control2Content,
				},
				{
				  path: '/control1Result',
				  name: 'control1Result',
				  component: control1Result,
				},
				{
				  path: '/control1Selection',
				  name: 'control1Selection',
				  component: control1Selection,
				},
				{
				  path: '/control3Summary',
				  name: 'control3Summary',
				  component: control3Summary,
				},
				{
				  path: '/control3Wordshockjc',
				  name: 'control3Wordshockjc',
				  component: control3Wordshockjc,
        },
        {
				  path: '/control3SymbolReport',
				  name: 'control3SymbolReport',
				  component: control3SymbolReport,
        },
        {
				  path: '/control3Wordshocksx',
				  name: 'control3Wordshocksx',
				  component: control3Wordshocksx,
				},
				{
				  path: '/control3Synchronoustext',
				  name: 'control3Synchronoustext',
				  component: control3Synchronoustext,
				},
				{
				  path: '/control3Phoneticalphabet',
				  name: 'control3Phoneticalphabet',
				  component: control3Phoneticalphabet,
				},
				{
				  path: '/control3RootWordReport',
				  name: 'control3RootWordReport',
				  component: control3RootWordReport,
				},
				{
				  path: '/control3CourseReport',
				  name: 'control3CourseReport',
				  component: control3CourseReport,
        }
        ,
				{
				  path: '/control3ReadReport',
				  name: 'control3ReadReport',
				  component: control3ReadReport,
        }
        ,
				{
				  path: '/control3YufaReport',
				  name: 'control3YufaReport',
				  component: control3YufaReport,
				},
				{
					path: '/dictationtools',
					name: 'dictationtools',
					component: dictationtools,
				}
			]
    },
		{
		  path: '/login',
		  name: 'login',
		  component: login,
		},
		{
		  path: '/examination',
		  name: 'examination',
		  component: examination,
		},
		{
			path:'/hklogin',
			name:'hklogin',
			component:hklogin
		}
  ]
});
